<template>
    <div>

        <h1>Cadastro de Pessoa</h1>
        <div style="text-align: right; width: 100%;" class="mb-5">
                <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 90px; cursor: pointer; background-color: #007BFF;" @click="SalvarParte()">
                    <label style="color: white; vertical-align: middle; cursor: pointer;"><u>S</u>alvar</label>
                </button>
                <button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 90px; cursor: pointer; background-color: white;" @click="Voltar()">
                    <label style="color: #007BFF; vertical-align: middle; cursor: pointer;"><u>V</u>oltar</label>
                </button>
        </div>
        <div class="row">
            <div class="col-12 form-container mb-3">
                <div class="row">
                    <div class="col-12" v-if="dados_parte_cadastrar.cb_sem_cpf" style="display: flex; align-items: center;">
                        <h4>Cadastro sem CPF/CPNJ:</h4>
                        <select class="form-control custom-select-sm custom-dropdown" v-model="dados_parte_cadastrar.sem_cpf_motivo" style="max-width: 300px; margin-left: 10px;">
                            <option :value="''" selected disabled></option>
                            <option :value="'estrangeiro'">Estrangeiro sem CPF</option>
                            <option :value="'indigente'">Indigente</option>
                            <option :value="'menor18'">Menor de idade</option>
                            <option :value="'precatoria'">Precatória</option>
                            <option :value="'preso'">Preso</option>
                        </select>
                        
                    </div>
                    <div class="col-12" v-else style="display: flex; align-items: center;">
                        <div>
                            <h4 v-if="dados_parte_cadastrar.tipo_pessoa=='PF'" style="margin-bottom: 0;">CPF:</h4>
                            <h4 v-else style="margin-bottom: 0;">CNPJ:</h4>
                        </div>
                        
                        <input v-if="dados_parte_cadastrar.tipo_pessoa == 'PF'"
                               type="text"
                               v-model="dados_parte_cadastrar.documento_pessoa"
                               class="form-control"
                               style="max-width: 300px; margin-left: 10px;"
                               v-mask="'###.###.###-##'"
                               @change="verificarCPFouCNPJ" />
                        
                        <input v-else
                               type="text"
                               :value="dados_parte_cadastrar.documento_pessoa"
                               class="form-control"
                               style="max-width: 300px; margin-left: 10px;"
                               maxlength="18"
                               
                               @input="aplicarMascaraCnpjCadastro($event)"
                               @change="verificarCPFouCNPJ" />
                    </div>
                    <div class="col-12 mt-1">
                        <label for="nome"><strong><u>N</u>ome:</strong></label>
                        <input type="text" v-model="dados_parte_cadastrar.pesquisar_nome" class="form-control" />
                    </div>
                    <div class="col-2 mt-1">
                        <label for="sexo"><strong><u>S</u>exo:</strong></label>
                        <select class="form-select custom-select-sm custom-dropdown" v-model="dados_parte_cadastrar.sexo">
                            <option :value="''" selected disabled></option>
                            <option :value="'M'">Masculino</option>
                            <option :value="'F'">Feminino</option>
                            <option :value="'O'">Outro</option>
                        </select>
                    </div>
                    <div class="col-2 mt-1">
                        <label for="estado_civil"><strong>Es<u>t</u>ado Civil:</strong></label>
                        <select class="form-select custom-select-sm custom-dropdown" v-model="dados_parte_cadastrar.estado_civil">
                            <option :value="''" selected disabled></option>
                            <option :value="'solteiro'">Solteiro(a)</option>
                            <option :value="'casado'">Casado(a)</option>
                            <option :value="'divorciado'">Divorciado(a)</option>
                            <option :value="'viuvo'">Viúvo(a)</option>
                        </select>
                    </div>
                    <div class="col-4 mt-1">
                        <label for="data_nascimento"><strong>Data de N<u>a</u>scimento:</strong></label>
                        <div style="display: flex; align-items: center;">
                            <input type="date" class="form-control" id="data_nascimento" v-model="dados_parte_cadastrar.data_nascimento" style="flex-grow: 1;">
                            <img :src='BASE_URL+"imagens/icons/icone_calendario.jpg"' style="width: 32px; height: 32px; margin-left: 10px;" />
                        </div>
                    </div>
                    <div class="col-4 mt-1">
                        <label for="profissao">Pro<u>fi</u>ssão:</label>
                        <input type="text" class="form-control" id="profissao" v-model="dados_parte_cadastrar.profissao">
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 mt-1">
                        <label for="profissao"><strong>Na<u>c</u>ionalidade:</strong></label>
                        <select class="form-select" id="nacionalidade" v-model="dados_parte_cadastrar.nacionalidade">
                            <option v-for="pais in paises" :key="pais.sigla" :value="pais.sigla">
                                {{ pais.gentilico }}
                            </option>
                        </select>
                    </div>
                    <div class="col-2 mt-1">
                        <label for="naturalidade">Naturali<u>d</u>ade:</label>
                        <select class="form-select" id="estado" v-model="dados_parte_cadastrar.uf">
                            <option v-for="(estado, sigla) in estados" :key="sigla" :value="sigla">{{ estado.sigla }}</option>
                        </select>
                    </div>
                    <div class="col-4 mt-1">
                        <label for="cidade" style="visibility: hidden;"><strong>Naturalidade:</strong></label>
                        <select class="form-select" id="cidade" v-model="dados_parte_cadastrar.cidade">
                            <option v-for="cidade in cidadesFiltradas" :key="cidade" :value="cidade">{{ cidade }}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 mt-1">
                        <label for="nome_mae">Nome Mã<u>e</u>:</label>
                        <input type="text" class="form-control" id="nome_mae" v-model="dados_parte_cadastrar.nome_mae">
                    </div>
                    <div class="col-6 mt-1">
                        <label for="nome_pai">N<u>o</u>me Pai:</label>
                        <input type="text" class="form-control" id="nome_pai" v-model="dados_parte_cadastrar.nome_pai">
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 mt-1">
                        <label for="nome_mae">Escolaridade:</label>
                        <select class="form-select custom-select-sm custom-dropdown" v-model="dados_parte_cadastrar.escolaridade">
                            <option :value="''" selected disabled>Selecione o nível de escolaridade</option>
                            <option value="analfabeto">Analfabeto</option>
                            <option value="ensino_fundamental_incompleto">Ensino Fundamental Incompleto</option>
                            <option value="ensino_fundamental_completo">Ensino Fundamental Completo</option>
                            <option value="ensino_medio_incompleto">Ensino Médio Incompleto</option>
                            <option value="ensino_medio_completo">Ensino Médio Completo</option>
                            <option value="ensino_tecnico">Ensino Técnico</option>
                            <option value="ensino_superior_incompleto">Ensino Superior Incompleto</option>
                            <option value="ensino_superior_completo">Ensino Superior Completo</option>
                            <option value="pos_graduacao_especializacao">Pós-Graduação/Especialização</option>
                            <option value="mestrado">Mestrado</option>
                            <option value="doutorado">Doutorado</option>
                        </select>
                    </div>
                    <div class="col-6 mt-1">
                        <label for="nome_pai">Complemento:</label>
                        <input type="text" class="form-control" id="nome_pai" v-model="dados_parte_cadastrar.complemento">
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="$store.state.cadastro_parte_dados.cb_sem_cpf">
            <div class="col-12 form-container mb-3">
                <div class="row">
                    <div class="col-12"><h4>Outros documentos</h4></div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label for="endereco_tipo"><strong>Documentos:</strong></label>
                        <select class="form-select custom-select-sm custom-dropdown" v-model="outros_documentos_tela.documento_tipo">
                            <option value="rg">RG</option>
                            <option value="passaporte">Passaporte</option>
                            <option value="CTPS">Carteira de Trabalho</option>
                            <option value="CartaoSUS">Cartão SUS</option>
                            <option value="cert_nascimento">Certidão Nascimento</option>
                            <option value="rne">Registro Nacional de Estrangeiro</option>
                            <option value="outro">Outro</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <label for="contdocumento_principalatos"><strong>Principal:</strong></label>
                        <div style="display: flex; align-items: center;">
                            <input type="text" class="form-control" id="documento_principal" v-model="outros_documentos_tela.documento_principal" style="flex-grow: 1;">
                        </div>
                    </div>
                    <div class="col-3">
                        <label for="documento_complementar1">Complementar 01:</label>
                        <div style="display: flex; align-items: center;">
                            <input type="text" class="form-control" id="documento_complementar1" v-model="outros_documentos_tela.documento_complementar1" style="flex-grow: 1;">
                        </div>
                    </div>
                    <div class="col-3">
                        <label for="documento_complementar2">Complementar 02:</label>
                        <div style="display: flex; align-items: center;">
                            <input type="text" class="form-control" id="documento_complementar2" v-model="outros_documentos_tela.documento_complementar2" style="flex-grow: 1;">
                        </div>
                    </div>
                    <div class="col-3">
                        <label for="data_emissao">Data de Emissão:</label>
                        <div style="display: flex; align-items: center;">
                            <input type="date" class="form-control" id="data_emissao" v-model="outros_documentos_tela.data_emissao" style="flex-grow: 1;">
                            <img :src='BASE_URL+"imagens/icons/icone_calendario.jpg"' style="width: 32px; height: 32px; margin-left: 10px;" />
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12" style="text-align: right;">
                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 90px; cursor: pointer; background-color: #007BFF;" @click="IncluirDocumento()">
                            <label style="color: white; vertical-align: middle; cursor: pointer;">In<u>c</u>luir</label>
                        </button>
                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 90px; cursor: pointer; background-color: white;" @click=LimparDocumento()>
                            <label style="color: #007BFF; vertical-align: middle; cursor: pointer;"><u>L</u>impar</label>
                        </button>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12" style="text-align: right;">
                        <div class="card-body mb-2">
                            <table class="table table-striped table-bordered mt-2 border">
                                <thead>
                                    <tr class="text-center">
                                        <th scope="col" style="background-color: lightgrey; display: none;">id</th>
                                        <th scope="col" style="background-color: lightgrey;">Documento</th>
                                        <th scope="col" style="background-color: lightgrey;">Principal</th>
                                        <th scope="col" style="background-color: lightgrey;">Complementar 01</th>
                                        <th scope="col" style="background-color: lightgrey;">Complementar 02</th>
                                        <th scope="col" style="background-color: lightgrey;">Data Emissão</th>
                                        <th scope="col" style="background-color: lightgrey;">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="documento in outros_documentos">
                                        <td style="display: none;">{{ documento.id }}</td>
                                        <td style="text-align: left;">{{ documento.documento_tipo }}</td>
                                        <td style="text-align: left;">{{ documento.documento_principal }}</td>
                                        <td style="text-align: left;">{{ documento.documento_complementar1 }}</td>
                                        <td style="text-align: left;">{{ documento.documento_complementar2 }}</td>
                                        <td style="text-align: left;">{{ documento.data_emissao }}</td>
                                        <td style="text-align: center;">
                                            <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 50px; background-color: rgb(235, 234, 234); cursor: pointer;" @click="RemoverDocumento(documento.documento_principal)">
                                                <img :src='BASE_URL+"imagens/icons/assuntos_remover.png"' width="20px">
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <hr />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 form-container mb-3">
                <div class="row">
                    <div class="col-12"><h4>Endereço(s)</h4></div>
                </div>
                <div class="row">
                    <div class="col-2">
                        <label for="endereco_tipo"><strong><u>T</u>ipo:</strong></label>
                        <select class="form-select custom-select-sm custom-dropdown" v-model="endereco_tela.endereco_tipo">
                            <option value="residencial">Residencial</option>
                            <option value="comercial">Comercial</option>
                            <option value="outro">Outro</option>
                        </select>
                    </div>
                    <div class="col-2">
                        <label for="endereco_cep"><strong>CEP:</strong></label>
                        <div style="display: flex; align-items: center;">
                            <input type="text" class="form-control" id="nome_pai" v-model="endereco_tela.endereco_cep" style="flex-grow: 1;" v-mask="'#####-###'">
                            <a href="#"><span class="material-icons">search</span></a>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <label for="endereco_logradouro"><strong>Logradouro:</strong></label>
                        <input type="text" class="form-control" id="endereco_logradouro" v-model="endereco_tela.endereco_logradouro">
                    </div>
                    <div class="col-2">
                        <label for="endereco_numero"><strong>Número:</strong></label>
                        <input type="text" class="form-control" id="endereco_numero" v-model="endereco_tela.endereco_numero">
                    </div>
                    <div class="col-3">
                        <label for="endereco_complemento"><strong>Complemento:</strong></label>
                        <input type="text" class="form-control" id="endereco_complemento" v-model="endereco_tela.endereco_complemento">
                    </div>
                    <div class="col-3">
                        <label for="endereco_bairro"><strong>Bairro:</strong></label>
                        <input type="text" class="form-control" id="endereco_bairro" v-model="endereco_tela.endereco_bairro">
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label for="endereco_pais"><strong>Paí<u>s</u>:</strong></label>
                        <select class="form-select" id="endereco_pais" v-model="endereco_tela.endereco_pais">
                            <option v-for="pais in paises" :key="pais.sigla" :value="pais.sigla">
                                {{ pais.nome_pais }}
                            </option>
                        </select>
                    </div>
                    <div class="col-2">
                        <label for="endereco_uf"><strong>UF:</strong></label>
                        <select class="form-select" id="estado" v-model="endereco_tela.endereco_uf">
                            <option v-for="(estado, sigla) in estados" :key="sigla" :value="sigla">{{ estado.sigla }}</option>
                        </select>
                    </div>
                    <div class="col-4">
                        <label for="endereco_cidade"><strong>Cidade:</strong></label>
                        <input type="text" class="form-control" id="endereco_cidade" v-model="endereco_tela.endereco_cidade">
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12" style="text-align: right;">
                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 90px; cursor: pointer; background-color: #007BFF;" @click="Incluir()">
                            <label style="color: white; vertical-align: middle; cursor: pointer;">In<u>c</u>luir</label>
                        </button>
                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 90px; cursor: pointer; background-color: white;" @click=LimparEndereco()>
                            <label style="color: #007BFF; vertical-align: middle; cursor: pointer;"><u>L</u>impar</label>
                        </button>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12" style="text-align: right;">
                        <div class="card-body mb-2">
                            <table class="table table-striped table-bordered mt-2 border">
                                <thead>
                                    <tr class="text-center">
                                        <th scope="col" style="background-color: lightgrey; display: none;">id</th>
                                        <th scope="col" style="background-color: lightgrey;">Tipo</th>
                                        <th scope="col" style="background-color: lightgrey;">Endereço</th>
                                        <th scope="col" style="background-color: lightgrey;">Cidade</th>
                                        <th scope="col" style="background-color: lightgrey;">Ativo?</th>
                                        <th scope="col" style="background-color: lightgrey;">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="endereco in enderecos">
                                        <td style="display: none;">{{ endereco.id }}</td>
                                        <td style="text-align: left;">{{ endereco.endereco_tipo }}</td>
                                        <td style="text-align: left;">{{ endereco.endereco_logradouro }}, {{ endereco.endereco_numero }}, {{ endereco.endereco_complemento ? endereco.endereco_complemento + ',' : '' }} {{ endereco.endereco_bairro ? endereco.endereco_bairro + ',' : '' }} {{ endereco.endereco_cep ? endereco.endereco_cep + '' : '' }}</td>
                                        <td style="text-align: left;">{{ endereco.endereco_cidade }}/{{ endereco.endereco_uf }}</td>
                                        <td style="text-align: center;">
                                            <input type="checkbox" v-model="endereco.ativo">
                                        </td>

                                        <td style="text-align: center;">
                                            <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 50px; background-color: rgb(235, 234, 234); cursor: pointer;" @click="RemoverEndereco(endereco.endereco_logradouro, endereco.endereco_numero);">
                                                <img :src='BASE_URL+"imagens/icons/assuntos_remover.png"' width="20px">
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <hr />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 form-container mb-3">
                <div class="row">
                    <div class="col-12"><h4>Contato(s)</h4></div>
                </div>
                <div class="row">
                    <div class="col-2">
                        <label for="endereco_tipo"><strong>Forma de Contato:</strong></label>
                        <select class="form-select custom-select-sm custom-dropdown" v-model="contato_tela.contato_tipo">
                            <option value="telefone_residencial">Telefone Residencial</option>
                            <option value="telefone_comercial">Telefone Comercial</option>
                            <option value="celular">Celular</option>
                            <option value="email">E-mail</option>
                        </select>
                    </div>
                    <div class="col-10">
                        <label for="contatos"><strong>Contato:</strong></label>
                        <div style="display: flex; align-items: center;">
                            <input type="text" class="form-control" id="nome_pai" v-model="contato_tela.contato" style="flex-grow: 1;">
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12" style="text-align: right;">
                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 90px; cursor: pointer; background-color: #007BFF;" @click="IncluirContato()">
                            <label style="color: white; vertical-align: middle; cursor: pointer;">In<u>c</u>luir</label>
                        </button>
                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 90px; cursor: pointer; background-color: white;" @click=LimparContato()>
                            <label style="color: #007BFF; vertical-align: middle; cursor: pointer;"><u>L</u>impar</label>
                        </button>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12" style="text-align: right;">
                        <div class="card-body mb-2">
                            <table class="table table-striped table-bordered mt-2 border">
                                <thead>
                                    <tr class="text-center">
                                        <th scope="col" style="background-color: lightgrey; display: none;">id</th>
                                        <th scope="col" style="background-color: lightgrey;">Tipo</th>
                                        <th scope="col" style="background-color: lightgrey;">Contato</th>
                                        <th scope="col" style="background-color: lightgrey;">Receber prazos por email?</th>
                                        <th scope="col" style="background-color: lightgrey;">Receber inf. da distribuição por email?</th>
                                        <th scope="col" style="background-color: lightgrey;">Usar email para esqueci senha?</th>
                                        <th scope="col" style="background-color: lightgrey;">Confirmado?</th>
                                        <th scope="col" style="background-color: lightgrey;">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="contato in contatos">
                                        <td style="display: none;">{{ contato.id }}</td>
                                        <td style="text-align: left;">{{ contato.contato_tipo }}</td>
                                        <td style="text-align: left;">{{ contato.contato }}</td>
                                        <td style="text-align: center;">
                                            <input type="checkbox" v-model="contato.receber_prazo_por_email" :disabled="contato.contato_tipo !== 'email'">
                                        </td>
                                        <td style="text-align: center;">
                                            <input type="checkbox" v-model="contato.receber_info_distribuicao_email" :disabled="contato.contato_tipo !== 'email'">
                                        </td>
                                        <td style="text-align: center;">
                                            <input type="checkbox" v-model="contato.usar_email_para_esqueci_senha" :disabled="contato.contato_tipo !== 'email'">
                                        </td>
                                        <td style="text-align: center;">
                                            <input type="checkbox" v-model="contato.confirmado">
                                        </td>
                                        <td style="text-align: center;">
                                            <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 50px; background-color: rgb(235, 234, 234); cursor: pointer;" @click="RemoverContato(contato.contato)">
                                                <img :src='BASE_URL+"imagens/icons/assuntos_remover.png"' width="20px">
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <hr />
                        </div>


                    </div>
                </div>
            </div>
        </div>
        <div style="text-align: right; width: 100%;" class="mb-5">
            <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 90px; cursor: pointer; background-color: #007BFF;" @click="SalvarParte()">
                <label style="color: white; vertical-align: middle; cursor: pointer;"><u>S</u>alvar</label>
            </button>
            <button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 90px; cursor: pointer; background-color: white;" @click="Voltar()">
                <label style="color: #007BFF; vertical-align: middle; cursor: pointer;"><u>V</u>oltar</label>
            </button>
        </div>
    </div>
  </template>
  
<script>

export default {
    data() {
        return {
            BASE_URL: window.Laravel.baseUrl,
            dados_parte_cadastrar: {},
            paises: [],
            estados: [],
            polo: 0,

            endereco_tela: {
                id: '',
                endereco_tipo: '',
                endereco_logradouro: '',
                endereco_numero: '',
                endereco_cep: '',
                endereco_complemento: '',
                endereco_bairro: '',
                endereco_pais: '',
                endereco_uf: '',
                endereco_cidade: '',
            },
            contato_tela:{
                id: '',
                contato_tipo: '',
                contato: '',
                receber_prazo_por_email: false,
                receber_info_distribuicao_email: false,
                usar_email_para_esqueci_senha: false,
                confirmado: false,
            },
            outros_documentos_tela: {
                id: '',
                documento_tipo: '',
                documento_principal: '',
                documento_complementar1: '',
                documento_complementar2: '',
                data_emissao: '',
            },
            enderecos: [],
            contatos: [],
            outros_documentos: [],
        };
    },
    computed: {
        cidadesFiltradas() {
            if (this.dados_parte_cadastrar.uf && this.estados[this.dados_parte_cadastrar.uf]) {
                return this.estados[this.dados_parte_cadastrar.uf].cidades;
            }
            return [];
        }
    },
    methods: {
        verificarCPFouCNPJ() {
            const cpfCnpj = this.dados_parte_cadastrar.documento_pessoa;
            if (!cpfCnpj) return;
            const raw = cpfCnpj.replace(/[^A-Za-z0-9]/g, '');
            if (raw.length >= 14) {
                this.buscarInformacoes(cpfCnpj);
            }
        },
        aplicarMascaraCnpjCadastro(event) {
            // Remove não-alfanuméricos e converte para maiúsculas
            let input = event.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
            // Posições 1-12: qualquer alfanumérico
            let corpo = input.substring(0, 12);
            // Posições 13-14 (DV): somente dígitos
            let dv = input.substring(12).replace(/[^0-9]/g, '').substring(0, 2);
            let raw = corpo + dv;
            // Aplica máscara: AA.AAA.AAA/AAAA-##
            let masked = '';
            for (let i = 0; i < raw.length; i++) {
                if (i === 2 || i === 5) masked += '.';
                else if (i === 8) masked += '/';
                else if (i === 12) masked += '-';
                masked += raw[i];
            }
            this.dados_parte_cadastrar.documento_pessoa = masked;
            event.target.value = masked;
        },
        async buscarInformacoes(cpfCnpj) {
            axios.get(this.BASE_URL + 'parte/buscar', { params: { query: cpfCnpj } })
                .then(response => {

                    if (!response.data.success) {
                        //console.log(response.data.message); // Exibe a mensagem de "Nenhuma parte encontrada..."
                        return; // Interrompe a execução adicional da função
                    }

                    this.dados_parte_cadastrar.cb_sem_cpf = response.data.pessoa.pessoa_sem_cpf;
                    this.dados_parte_cadastrar.sem_cpf_motivo = response.data.pessoa.pessoa_sem_cpf_tipo;
                    this.dados_parte_cadastrar.tipo_pessoa = response.data.pessoa.pessoa_tipo;
                    this.dados_parte_cadastrar.pesquisar_nome = response.data.pessoa.nome;
                    this.dados_parte_cadastrar.estado_civil = response.data.pessoa.estado_civil;
                    this.dados_parte_cadastrar.sexo = response.data.pessoa.sexo;
                    this.dados_parte_cadastrar.data_nascimento = response.data.pessoa.data_nascimento.split(' ')[0]; //Para receber a formatação de forma correta
                    this.dados_parte_cadastrar.profissao = response.data.pessoa.profissao;
                    this.dados_parte_cadastrar.nacionalidade = response.data.pessoa.nacionalidade;
                    this.dados_parte_cadastrar.uf = response.data.pessoa.naturalidade;
                    this.dados_parte_cadastrar.cidade = response.data.pessoa.cidade;
                    this.dados_parte_cadastrar.nome_mae = response.data.pessoa.nome_mae;
                    this.dados_parte_cadastrar.nome_pai = response.data.pessoa.nome_pai;
                    this.dados_parte_cadastrar.escolaridade = response.data.pessoa.escolaridade;
                    this.dados_parte_cadastrar.complemento = response.data.pessoa.complemento;

                    response.data.pessoa.contatos.forEach(contato => {
                        // Cria um novo objeto de contato formatado conforme a nova estrutura
                        const contatoFormatado = {
                            id: contato.id || '',
                            contato_tipo: contato.tipo_forma_contato || '',
                            contato: contato.contato || '',
                            receber_prazo_por_email: contato.receber_prazos_email === 1,
                            receber_info_distribuicao_email: contato.receber_info_da_distribuicao_por_email === 1,
                            usar_email_para_esqueci_senha: contato.usar_email_para_esqueci_senha === 1,
                            confirmado: contato.confirmado === 1,
                        };

                        // Adiciona o objeto de contato formatado ao array this.contatos
                        this.contatos.push(contatoFormatado);
                    });
                    
                    response.data.pessoa.enderecos.forEach(endereco => {
                        const enderecoFormatado = {
                            id: endereco.id || '',
                            endereco_tipo: endereco.endereco_tipo || '',
                            endereco_logradouro: endereco.logradouro || '',
                            endereco_numero: endereco.numero || '',
                            endereco_cep: endereco.cep || '',
                            endereco_complemento: endereco.complemento || '',
                            endereco_bairro: endereco.bairro || '',
                            endereco_pais: endereco.pais || '',
                            endereco_uf: endereco.uf || '',
                            endereco_cidade: endereco.cidade || '',
                            ativo: endereco.ativo || '',
                        };
                        this.enderecos.push(enderecoFormatado);
                    });

                })
                .catch(error => {
                    console.error("Erro ao buscar usuários:", error);
                });

        },

        Voltar(){
            this.$store.commit('toggleCadastroParteVisivel', this.dados_parte_cadastrar);
        },
        SalvarParte(){
            if(!this.dados_parte_cadastrar.cb_sem_cpf){
                if(this.dados_parte_cadastrar.documento_pessoa == ""){
                    alert("Campo CPF/CNPJ não pode ser vazio.");
                    return;
                }
            }

            if(this.dados_parte_cadastrar.pesquisar_nome == ''){
                alert("Campo nome não pode ser vazio.");
                return;
            }

            const dados_gravar = {
                    dados_parte_cadastrar: this.dados_parte_cadastrar,
                    enderecos: this.enderecos,
                    contatos: this.contatos,
                    outrosDocumentos: this.outros_documentos,
                };

            axios.post(this.BASE_URL + 'salvar_pessoa_parte', dados_gravar)
                .then(response => {

                    alert(this.dados_parte_cadastrar.pesquisar_nome + ' salvo com sucesso.');

                    this.dados_parte_cadastrar = response.data.pessoa; //Esse response.data está retornando todas as informações dessa pessoa recém cadastrada com seus endereços e contatos

                    if (this.polo == 1) {
                        const jaExiste = this.$store.state.processo.polo_ativo?.find(parte => parte.id === this.dados_parte_cadastrar.id);
                        if (!jaExiste) {
                            this.dados_parte_cadastrar.selecaoPolo = 'autor';
                            this.$store.commit('setProcessoPoloAtivo', this.dados_parte_cadastrar);
                            this.sincronizarComBancoDeDados(this.dados_parte_cadastrar, 'ativo');
                        }
                    } 
                    else if (this.polo == 2) {
                        const jaExiste = this.$store.state.processo.polo_passivo?.find(parte => parte.id === this.dados_parte_cadastrar.id);
                        if (!jaExiste) {
                            this.dados_parte_cadastrar.selecaoPolo = 'reu';

                            this.$store.commit('setProcessoPoloPassivo', this.dados_parte_cadastrar);

                            this.sincronizarComBancoDeDados(this.dados_parte_cadastrar, 'passivo');

                        }
                    }

                    this.$store.commit('toggleCadastroParteVisivel', this.dados_parte_cadastrar); //Essa linha que deixa visivel e invisível o cadastro de pessoa.
                })
                .catch(error => {
                    // Tratar erro na requisição
                    console.error('Erro ao enviar dados:', error);
                });


        },
        Incluir(){
            if (this.endereco_tela.endereco_tipo == ''){
                alert("Selecione o tipo do endereço.");
                return;
            }

            if (this.endereco_tela.endereco_logradouro == ''){
                alert("Campo Logradouro não pode ser vazio.");
                return;
            }

            if (this.endereco_tela.numero == ''){
                alert("Campo Número do endereço não pode ser vazio.");
                return;
            }

            if (this.endereco_tela.endereco_bairro == ''){
                alert("Campo Bairro não pode ser vazio.");
                return;
            }

            if (this.endereco_tela.cidade == ''){
                alert("Campo Cidade não pode ser vazio.");
                return;
            }


            const novoEndereco = {
                id: '',
                endereco_tipo: this.endereco_tela.endereco_tipo,
                endereco_logradouro: this.endereco_tela.endereco_logradouro,
                endereco_numero: this.endereco_tela.endereco_numero,
                endereco_cep: this.endereco_tela.endereco_cep,
                endereco_complemento: this.endereco_tela.endereco_complemento,
                endereco_bairro: this.endereco_tela.endereco_bairro,
                endereco_pais: this.endereco_tela.endereco_pais,
                endereco_uf: this.endereco_tela.endereco_uf,
                endereco_cidade: this.endereco_tela.endereco_cidade,
            };
            this.enderecos.push(novoEndereco);
            this.LimparEndereco();
        },
        LimparEndereco(){
            this.endereco_tela.endereco_tipo = this.endereco_tela.endereco_logradouro = this.endereco_tela.endereco_numero = this.endereco_tela.endereco_complemento = this.endereco_tela.endereco_bairro = this.endereco_tela.endereco_pais =  this.endereco_tela.endereco_uf = this.endereco_tela.endereco_cep = this.endereco_tela.endereco_cidade = '';
        },
        RemoverEndereco(logradouro, numero){
            // Encontra o índice do endereço que corresponde aos critérios fornecidos
            const index = this.enderecos.findIndex(endereco => 
                endereco.endereco_logradouro === logradouro && endereco.endereco_numero === numero);
            
            // Se um endereço correspondente for encontrado, remove-o do array
            if (index !== -1) {
                this.enderecos.splice(index, 1);
            }
        },
        IncluirContato(){

            if (this.contato_tela.contato_tipo == ''){
                alert("Selecione a forma de contato.");
                return;
            }

            if (this.contato_tela.contato == ''){
                alert("Campo de contato não pode ser vazio.");
                return;
            }

            const novoContato = {
                id: '',
                contato_tipo: this.contato_tela.contato_tipo,
                contato: this.contato_tela.contato,
                receber_prazo_por_email: false,
                receber_info_distribuicao_email: false,
                usar_email_para_esqueci_senha: false,
                confirmado: false,
            };
            this.contatos.push(novoContato);
            this.LimparContato();
        },
        LimparContato(){
            this.contato_tela.contato_tipo = this.contato_tela.contato = '';
        },
        RemoverContato(contato_remover){
            // Encontra o índice do contato com o id fornecido
            const index = this.contatos.findIndex(contato => contato.contato === contato_remover);
        
            // Se o contato for encontrado, remove-o do array
            if (index !== -1) {
                this.contatos.splice(index, 1);
            }
        },
        IncluirDocumento(){

            if (this.outros_documentos_tela.documento_tipo == ''){
                alert("Selecione o tipo de documento que será inserido.");
                return;
            }

            if (this.outros_documentos_tela.documento_principal == ''){
                alert("Campo Principal não pode ser vazio.");
                return;
            }

            const novoDocumento = {
                id: '',
                documento_tipo: this.outros_documentos_tela.documento_tipo,
                documento_principal: this.outros_documentos_tela.documento_principal,
                documento_complementar1: this.outros_documentos_tela.documento_complementar1,
                documento_complementar2: this.outros_documentos_tela.documento_complementar2,
                data_emissao: this.outros_documentos_tela.data_emissao,
            };
            this.outros_documentos.push(novoDocumento);
            this.LimparDocumento();
        },
        LimparDocumento(){
            this.outros_documentos.documento_tipo = this.outros_documentos.documento_principal = this.outros_documentos.documento_complementar1 = this.outros_documentos.documento_complementar2 = this.outros_documentos.data_emissao = '';
        },
        RemoverDocumento(documento_principal){
            // Encontra o índice do contato com o id fornecido
            const index = this.outros_documentos.findIndex(documento => documento.documento_principal === documento_principal);
            
            // Se o contato for encontrado, remove-o do array
            if (index !== -1) {
                this.outros_documentos.splice(index, 1);
            }
        },
        CarregarPaises(){
                fetch(this.BASE_URL + 'common/nacionalidades.json')
                    .then(response => response.json())
                    .then(data => {
                        this.paises = data;
                    })
                    .catch(error => console.error('Erro ao carregar países:', error));
        },

        carregarEstados() {
            fetch(this.BASE_URL + 'common/cidades.json')
                .then(response => response.json())
                .then(data => {
                    this.estados = data;
                })
                .catch(error => {
                    console.error('Erro ao carregar estados:', error);
                });
        },

        sincronizarComBancoDeDados(pessoa, polo) {
            const poloAtivo = this.$store.state.processo.polo_ativo;
            const poloPassivo = this.$store.state.processo.polo_passivo;
            const processoId = this.$store.state.processo.id;

            axios.post(this.BASE_URL + 'sincronizar_partes_processo', { poloAtivo, poloPassivo, processoId })
                .then(response => {

                })
                .catch(error => {
                    console.error("Erro ao sincronizar polos:", error);
                });
        },

    },
    mounted() {
        this.dados_parte_cadastrar = this.$store.state.cadastro_parte_dados; //Vem da outra tela
        this.polo = this.dados_parte_cadastrar.polo;

        this.CarregarPaises();
        this.carregarEstados();
    },
    watch: {
            '$store.state.processo.polo_ativo': {
                handler(newValue, oldValue) {
                    this.sincronizarComBancoDeDados(newValue, 'ativo');
                },
                deep: true
            },
            '$store.state.processo.polo_passivo': {
                handler(newValue, oldValue) {
                    this.sincronizarComBancoDeDados(newValue, 'passivo');
                },
                deep: true
            }
        },
};
</script>

<style scoped>
h1{
  font-size: 26px;
}

.form-container {
    border: 1px solid gray; /* Borda fina cinza */
    padding: 10px;
    position: relative; /* Posição relativa para o posicionamento do título */
    margin-top: 5px; /* Espaçamento superior para visualização do título */
    margin-left: 5px;
    margin-right: 5px;
    border-radius: 5px;
    background-color: #FFFFFF;
}

.form-title {
    position: absolute; /* Posicionamento absoluto do título */
    top: -15px; /* Posiciona o título acima da borda */
    left: 10px; /* Espaçamento da esquerda para o título */
    background: white; /* Fundo branco para o título */
    padding: 0 1px; /* Espaçamento interno do título */
    font-weight: bold;;
}
</style>
  
